module.exports = __webpack_public_path__ + "static/media/not-found.65c4db89.svg";